import React, { useState, useEffect } from "react";
import { isAuthenticated } from "../../../auth/auth";
import IndividualKPIsCom from "../virtual-agent/IndividualKPIsCom";

function DashboardCom() {
  return !isAuthenticated() && <IndividualKPIsCom />;
}

export default DashboardCom;
